export const filterTypes = {
  inputText: 0,
  dropdownYesNo: 1,
  dropdownWithLocalData: 2,
  dropdownWithServerData: 3,
  rangePicker: 4,
};
